import React, { Component, ReactNode } from 'react';
import _ from 'lodash';
import ACLService from '../services/aclService';

interface ACLProps {
    response: any,
		accessType: string[],
		responseKey : 'allowedTo'| 'createdBy',
		layerType ?: string[],
		checkBoth ?: Boolean,
    children: ReactNode,
}

class ResponseBasedACL extends Component<ACLProps> {
    constructor(props: ACLProps) {
        super(props);
        this.hasAccess = this.hasAccess.bind(this);
    }

    hasAccess() {
        if (!_.isEmpty(this.props)) {
            const {
							response,
							accessType,
							layerType = [],
							responseKey,
							checkBoth = false,
						} = this.props;
            return ACLService.responseHasAccessTo(response, accessType, layerType, responseKey, checkBoth);
        } else {
            return false;
        }
    }

    render() {
        if (this.hasAccess()) {
            return <> {this.props.children} </>
        }
        return <></>;
    }
}

export default ResponseBasedACL;
